export { default } from './ServiceEdit'


// WEBPACK FOOTER //
// ./src/scenes/Administration/Service/ServiceEdit/index.js